import { z } from 'zod';

export const loginSchema = z.object({
  // Login identifier — accepts either an email or a username. Kept under the
  // `email` key for wire compatibility; the backend branches on '@' (usernames
  // can't contain '@') to pick the lookup column.
  email: z.string().trim().min(1, 'กรุณาใส่อีเมลหรือ username').max(255),
  password: z.string().min(8, 'รหัสผ่านอย่างน้อย 8 ตัวอักษร').max(200),
});

export type LoginInput = z.infer<typeof loginSchema>;
